import React, {useEffect, useRef} from 'react';
import {useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import * as party from 'party-js';
import {FiExternalLink} from "react-icons/fi";

function FreeGiftRedeemed(props) {
    const {id} = useParams()
    //@ts-ignore
    const metadata = useSelector((state)=>state.settings.metadata)
    const parsed = metadata ? JSON.parse(metadata) : {}
    const redemptions = parsed.gift_redemptions || []
    const el = useRef<HTMLDivElement>(null)
    const found = redemptions.find(i=>i.giftId === id)
    useEffect(() => {
        if(el && el.current) {
            party.confetti(el.current, {
                count: party.variation.range(50, 100),
                size: party.variation.range(0.5, 2),
                // angle: party.variation.range(55, 125),
                spread: party.variation.range(50, 70),
                // duration: party.variation.range(3000, 5000),
            });
            return () => {
                // party.reset();
            }
        }
    }, [el]);
    if(!found){
        return <div>Order not found</div>
    }else{
        return <div>
            <div className="fs-2 text-center" ref={el}>
                🎉 Your order is on the way
            </div>
            <div className="text-center">
                <a href={found?.statusPageUrl} target={"_blank"}>Track order <FiExternalLink /></a>
            </div>
        </div>
    }
}

export default FreeGiftRedeemed;
